<template>
  <!-- 座位查询 -->
  <div class="seat_listbox">
     <div class="seat_number">
       <p>您的座位号为：{{zuoTetx}}</p>
     </div>
     <div class="seat_html">
       <van-image class="topTai" :src="topTai" />
       <div class="seat_icon">
         <div class="icon_item" v-for="item in list[0].tag_color">
           <span class="zhan_seat iconfont" :style="'color:'+item.value">&#xe634;</span>
           <p>{{item.label}}</p>
         </div>
<!--
         <div class="icon_item">
           <span class="zhan_seat iconfont" style="color:#f45c43">&#xe634;</span>
           <p>占位</p>
         </div>-->
         <div class="icon_item">
           <span class="my_seat" style="background:#71a2ff;"></span>
           <p>我的位置</p>
         </div>
       </div>
       <div class="seat_topbtn">
         <span @click="qujing" :class="onTab  == 0?'active':''">查看全景图</span>
         <span @click="goMySeat" :class="onTab  == 1?'active':''">查看我的座位</span>
         <p>（点击座位查看详细信息）</p>
       </div>
       <div class="seat_inbox" :style="'height:'+boxStyle.height+'px'" ref="divWidth">
         <div class="in_list"  :style="'height:'+boxStyle.height2+'px;'"  id="listEl">
           <template v-for="item in list">
            <div>
             <ul class="quyu" ref="ulWidth">
               <li><b>区域名：{{item.area}} </b> <b>区域号：{{item.numbered}}</b></li>
             </ul>
            </div>
           <template v-for="items in item.array_seat">
            <div>
             <ul  ref="ulWidth">
               <li v-for="itemss in items" :class="[(itemss.line == myseat.hang && itemss.column == myseat.lie && myseat.qu == item.numbered)? 'active':'',itemss.checkDisabledState   ?'jin':'',itemss.seats ?'zhan':'']" @click="seatClick(item.area,itemss)">
                 <span class="iconfont" :style="itemss.color != ''? 'color:'+itemss.color:''" :ref="[(itemss.line == myseat.hang && itemss.column == myseat.lie && myseat.qu == item.numbered)? 'myRefBtn':'']">&#xe634;</span>
                 <p v-if="AlloyFinger.onNum > 0.8 && itemss.line == myseat.hang && itemss.column == myseat.lie && myseat.qu == item.numbered">{{itemss.member.member ? itemss.member.member.name : '无'}}</p>
                 <p v-else-if="AlloyFinger.onNum > 0.8 && itemss.line == (Number(myseat.hang)-1) && itemss.column == myseat.lie && myseat.qu == item.numbered">{{itemss.member.member ? itemss.member.member.name : '无'}}</p>
                 <p v-else-if="AlloyFinger.onNum > 0.8 && itemss.line == (Number(myseat.hang)+1) && itemss.column == myseat.lie && myseat.qu == item.numbered">{{itemss.member.member ? itemss.member.member.name : '无'}}</p>
                 <p v-else-if="AlloyFinger.onNum > 0.8 && itemss.line == myseat.hang  && itemss.column == (Number(myseat.lie) - 1) && myseat.qu == item.numbered">{{itemss.member.member ? itemss.member.member.name : '无'}}</p>
                 <p v-else-if="AlloyFinger.onNum > 0.8 && itemss.line == myseat.hang && (itemss.column == (Number(myseat.lie) + 1)) && myseat.qu == item.numbered">{{itemss.member.member ? itemss.member.member.name : '无'}}</p>
                 <p v-else-if="AlloyFinger.onNum > 0.8">{{itemss.seats}}</p>
               </li>
             </ul>
            </div>
            </template>
           </template>
         </div>
       </div>
<!--
       <div class="seat_btn">
         <van-button plain type="warning">关注查看更多</van-button>
       </div>
-->
     </div>
    <!--浮动按钮-->
<footerFixed :id="id"/>
  </div>
</template>

<script>
  import Transform from 'alloyfinger/asset/transform'
 import AlloyFinger from 'alloyfinger'
  import {
    formatDates,
    formatWeekDate
  } from "@/assets/js/date";
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        id: '',
        topTai:require('@/assets/images/seat/tai.png'),
        list: [
          {
            tag_color:{

            }
          }
        ],
        AlloyFinger:{
          maxNum:1,
          minNum:0,
          onNum:0,
        },//缩放配置
        boxStyle:{
          height:380,
          height2:0,
          width:0,
          width2:0,
          x:0,
          y:0,
        },
        myseat:{
          hang:0,
          lie:0,
           qu:0,
        },
        zuoTetx:'',
        footerNav: false,
        onTab:0,
      };
    },
    /* 时间过滤 */
    filters: {
      formatDates, //调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
      formatWeekDate
    },
    created: function() {
      var _this = this;
      _this.id = _this.$route.params.id
      _this.myseat.qu = _this.$route.params.q;
      _this.myseat.hang = _this.$route.params.h;
      _this.myseat.lie = _this.$route.params.l;
      _this.loadEnroll();
      // 自定义加载图标
      _this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration:0,
        overlay:true
      });

    },
    mounted:function(){
      let _this  = this;
      this.$nextTick(function () {

      })
    },
    methods: {
      seatClick(name,e){
        let _this = this;
        var texts = "<div style='text-align:left;'>";
        if(e.member.member != ''){
          if(e.member.member.name){
            texts += '姓名：'+e.member.member.name +'</br>'
           }
          if(e.member.member.tel){
            texts += '电话：'+e.member.member.tel +'</br>'
          }
          if(e.member.memberteam){
            texts += '机构：'+e.member.member.team +'</br>'
          }
          if(e.member.member.dep){
            texts += '部门：'+e.member.member.dep +'</br>'
          }
          if(e.member.member.job){
            texts += '职称：'+e.member.member.job +'</br>'
          }
          texts += '座位：'+ name + e.row+ e.seats +'</br>'
        }else{
          texts = '暂无座位信息！';
        }
        _this.$dialog.alert({
          title: '',
          message: texts+'</div>',
          confirmButtonColor:'#2b68da'
        }).then(() => {
          // on close
        });
      },
      //打开底部链接
      openFooterNav(val) {
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      loadEnroll() {
        var _this = this;
        let url = "/ac1/conference/seat/info";
        let params = {
          id: _this.id
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.list = res.posts;
            for(var i=0;i<_this.list.length;i++){
              if(_this.list[i].numbered == _this.myseat.qu){
                for(var h=0;h<_this.list[i].array_seat.length;h++){
                  for(var j =0;j<_this.list[i].array_seat[h].length;j++){
                    if(_this.list[i].array_seat[h][j].line == _this.myseat.hang && _this.list[i].array_seat[h][j].column == _this.myseat.lie){
                      _this.zuoTetx =_this.list[i].area +' '+ _this.list[i].array_seat[h][j].row + _this.list[i].array_seat[h][j].seats;
                    }
                  }
                }
              }
            }
             setTimeout(function(){
               _this.seatShow();
             },1000)
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });
      },
      qujing(){
        let _this = this;
        var el = document.getElementById("listEl");
        el.scaleX = el.scaleY =  _this.AlloyFinger.onNum = _this.AlloyFinger.minNum;
        el.translateX  = -(_this.boxStyle.x);
        el.translateY = -(_this.boxStyle.y);
        _this.onTab = 0;
      },
      goMySeat(){
        let _this = this;
        var el = document.getElementById("listEl");
        el.scaleX = el.scaleY =  _this.AlloyFinger.onNum = 1;
        var lefts = _this.$refs.myRefBtn[0].offsetParent.offsetLeft;
        var tops = _this.$refs.myRefBtn[0].offsetParent.offsetTop;
        var heis = _this.boxStyle.height/2;
        var wids = _this.boxStyle.width2/2;
        if(tops < heis){
          el.translateY = 0;
        }else if(tops >( _this.boxStyle.height2 - (heis))){
          el.translateY = -( _this.boxStyle.height2 - _this.boxStyle.height);
        }else{
          el.translateY = -(tops-heis);
        }

        if(lefts < wids){
          el.translateX = 0;
        }else if(tops >( _this.boxStyle.width - wids)){
          el.translateX = -( _this.boxStyle.width - _this.boxStyle.width2);
        }else{
          el.translateX = -(lefts-wids);
        }
        _this.onTab = 1;
       // el.translateX  = -(lefts-wids);
       // el.translateY = -(tops-heis);
      },
      seatShow(){
        let _this = this;
        var divWid = _this.$refs.divWidth.offsetWidth;
        var wlist = [];
        for(var i =0;i<_this.$refs.ulWidth.length;i++){
          wlist.push(_this.$refs.ulWidth[i].offsetWidth);
        }
        var ulWid =  wlist.reduce(function(a , b){
          return b > a ? b : a;
        });
        var ulHei = _this.$refs.ulWidth[1].offsetHeight;
        _this.AlloyFinger.minNum = (divWid/ulWid).toFixed(3);
        _this.AlloyFinger.onNum = (divWid/ulWid).toFixed(3);
        var hris = ulHei*_this.$refs.ulWidth.length*_this.AlloyFinger.onNum;
        _this.boxStyle.height2 = ulHei*_this.$refs.ulWidth.length;
        if(_this.boxStyle.height2 * _this.AlloyFinger.onNum > 380 ){
          _this.boxStyle.height = _this.boxStyle.height2
        }
        _this.boxStyle.width = ulWid;
        _this.boxStyle.width2 = divWid;
        _this.boxStyle.y = (Number(_this.boxStyle.height2)-Number(_this.boxStyle.height))/2;
        _this.boxStyle.x = (ulWid-divWid)/2;
        var el = document.getElementById("listEl");
        window.Transform(el);
        el.scaleX = el.scaleY =  _this.AlloyFinger.onNum;
        el.translateX  = -(_this.boxStyle.x);
        el.translateY = -(_this.boxStyle.y);
        _this.$toast.clear();
        var topPx;
        new AlloyFinger(el, {
          multipointStart: function () {
            //To.stopAll();
            //  _this.AlloyFinger.onNum = el.scaleX;
          },
          /* rotate: function (evt) {
              el.rotateZ += evt.angle;
            },*/
          pinch: function (evt) {
            /*_this.$toast(_this.AlloyFinger.onNum+'/'+_this.AlloyFinger.minNum);*/
           // var zooms = Number(_this.AlloyFinger.onNum) * evt.zoom;
            if(evt.zoom  > 1){
              el.scaleX = el.scaleY =  _this.AlloyFinger.onNum = 1;
              var lefts = _this.$refs.myRefBtn[0].offsetParent.offsetLeft;
              var tops = _this.$refs.myRefBtn[0].offsetParent.offsetTop;
              var heis = _this.boxStyle.height/2;
              var wids = _this.boxStyle.width2/2;
              if(tops < heis){
                el.translateY = 0;
              }else if(tops >( _this.boxStyle.height2 - (heis))){
                el.translateY = -( _this.boxStyle.height2 - _this.boxStyle.height);
              }else{
                el.translateY = -(tops-heis);
              }

              if(lefts < wids){
                el.translateX = 0;
              }else if(tops >( _this.boxStyle.width - wids)){
                el.translateX = -( _this.boxStyle.width - _this.boxStyle.width2);
              }else{
                el.translateX = -(lefts-wids);
              }
              _this.onTab = 1;
            }else{
              el.scaleX = el.scaleY =  _this.AlloyFinger.onNum = _this.AlloyFinger.minNum;
              _this.onTab = 0;
            }
          /*  _this.$toast(evt.zoom);

            if(zooms >= _this.AlloyFinger.minNum){
              _this.AlloyFinger.onNum = (Number(_this.AlloyFinger.onNum) * evt.zoom).toFixed(3);
              if(Number(_this.AlloyFinger.onNum) <= 1){
                el.scaleX = el.scaleY =  _this.AlloyFinger.onNum;
              }
            }*/

          },
          multipointEnd: function () {
            _this.AlloyFinger.onNum  = el.scaleX;
            if( el.scaleX <= _this.AlloyFinger.minNum){
              el.scaleX = _this.AlloyFinger.minNum;
              el.scaleY = _this.AlloyFinger.minNum;
              el.translateX  = -(_this.boxStyle.x);
              el.translateY = -(_this.boxStyle.y);
            }else if(el.scaleX > 1){
              el.scaleX = 1;
              el.scaleY = 1;
            }
            if(el.translateX >= -((_this.boxStyle.width*(1 - _this.AlloyFinger.onNum))/2)){
              el.translateX  = -((_this.boxStyle.width*(1 - _this.AlloyFinger.onNum))/2);
            }
            if(el.translateX <= -((_this.boxStyle.width - (_this.boxStyle.width*(1 - _this.AlloyFinger.onNum))/2)-divWid)){
              el.translateX  = -((_this.boxStyle.width - (_this.boxStyle.width*(1 - _this.AlloyFinger.onNum))/2)-divWid);
            }
            if(el.translateY >= -((_this.boxStyle.height2*(1 - _this.AlloyFinger.onNum))/2)){
              el.translateY  = -((_this.boxStyle.height2*(1 - _this.AlloyFinger.onNum))/2);
            }
            if(el.translateY <= -((_this.boxStyle.height2 - (_this.boxStyle.height2*(1 - _this.AlloyFinger.onNum))/2)-_this.boxStyle.height)){
              if((Number(_this.AlloyFinger.onNum)*_this.boxStyle.height2) > _this.boxStyle.height){
                el.translateY = -(_this.boxStyle.y);
                el.translateY  =  -((_this.boxStyle.height2 - (_this.boxStyle.height2*(1 - _this.AlloyFinger.onNum))/2)-_this.boxStyle.height);
              }else{
                el.translateY  =  -(_this.boxStyle.y);
              }

            }

          },
          pressMove: function (evt) {
            if(Number(_this.AlloyFinger.onNum) >= Number(_this.AlloyFinger.minNum)){
              el.translateX += evt.deltaX;
              el.translateY += evt.deltaY;
              evt.preventDefault();
            }
          },
          tap: function (evt) {
               // el.scaleX = 1;
            //  el.scaleY =1;
            //  _this.AlloyFinger.onNum = 1;
            //console.log(el.scaleX + "_" + el.scaleY + "_" + el.rotateZ + "_" + el.translateX + "_" + el.translateY);
            //console.log("tap");
          },
          doubleTap: function (evt) {
            // To.stopAll();
            /*   var box = el.getBoundingClientRect();
                var y = box.height - (( evt.changedTouches[0].pageY - topPx) * 2) - (box.height / 2 - ( evt.changedTouches[0].pageY - topPx));
                var x = box.width - (( evt.changedTouches[0].pageX) * 2) - (box.width / 2 - ( evt.changedTouches[0].pageX));
                el.scaleX = _this.AlloyFinger.maxNum;
                el.scaleY = _this.AlloyFinger.maxNum;
                el.translateX  = x;
                el.translateY = y; */
            //console.log("doubleTap");
          },
          longTap: function (evt) {
            //console.log("longTap");
          },
          swipe: function (evt) {
            //console.log("swipe" + evt.direction);
          }

        });
      }
    }
  };
</script>
<style lang="less">
  @keyframes myfirst
  {
    0% {opacity: 0.2;}
    50% {opacity: 1;}
    100% {opacity: 0.2;}
  }
  //座位查询
  .seat_listbox {
    width: 100%;
    min-height: 100vh;
    background: #FFF;
    .seat_number{
      width: 100%;
      height: 180px;
      background-image: url(../../../assets/images/seat/topBg.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      p{
        font-size: 34px;
        color: #FFF;
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-align: center;
        line-height: 180px;
      }
    }
    .seat_html{
      width: 100%;
      padding: 30px;
      .topTai{
        width: 100%;
        img{
          display: block;
          width: 100%;
        }
      }
      .seat_icon{
        width: 100%;
        overflow: hidden;
        padding-top: 20px;
        .icon_item{
          float: right;
          margin-right: 20px;
          span{
            display: block;
            width: 20px;
            height: 20px;
            margin: 8px 10px 0 0;
            float: left;
            &.iconfont{
              font-size: 24px;
              margin: 0px 10px 0 0;
              line-height: 40px;
            }
          }
          p{
            line-height: 40px;
            height: 40px;
            font-size: 24px;
            display: block;
            float: left;
          }
          .my_seat{
            animation: myfirst 1.6s infinite ease;
          }
        }
      }
      .seat_topbtn{
        width:600px;
        margin: 20px auto 0px;
        overflow: hidden;
        border: 1px solid #ebebeb;/*no*/
        border-bottom: none;
        span{
          color: #2b68da;
          padding: 15px 8px;
          font-size: 24px;
          width: 50%;
          float: left;
          text-align: center;
          cursor: pointer;
          border-bottom: 1px solid #ebebeb;/*no*/
          &.active{
            background: #2b68da;
            color: #FFF;
          }
        }
        p{
          width: 100%;
          font-size: 24px;
          color: #999;
          text-align: center;
          display: block;
          line-height: 50px;
          float: left;
          padding: 0 10px;
        }
      }
      .seat_inbox{
        width:600px;
        margin: 0px auto;
        overflow: hidden;
      //  background: #fefcfc;
        border: 1px solid #ebebeb;/*no*/
        position: relative;
        .in_list{
          position: absolute;
          .quyu{
            padding: 0px 20px;
            color: #409EFF;
            display: block!important;
            li{
              width: 100%;
              min-width: 100%;
              margin-left: 0px;
              margin-right: 0px;
              background: none;
              border: none;
              flex: none;
              font-size: 28px;
              b{
                color: #409EFF;
                margin-right: 30px;
              }
            }
          }
          ul{
            white-space: nowrap;
            display: inline-flex;
            overflow: hidden;
            li{
              flex: 1;
              float: left;
              width: 80px;
              height: 80px;
              line-height: 80px;
              border-radius: 10px;
              border: 1px solid #ebebeb;
              background: #d8d5d5;
              position: relative;
              margin: 20px;
              overflow: hidden;
              span{
                width: 100%;
                height: 100%;
                display: block;
                position: absolute;
                top: 0px;
                left: 0px;
                text-align: center;
                line-height: 80px;
                color: #fff;
                font-size: 50px;
                z-index: 1;
              }
              p{
               position: absolute;
                display: block;
                width: 100%;
                height: 100%;
                line-height: 80px;
                font-size: 24px;
                z-index: 2;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #999;
              }
              &.active{
                animation: myfirst 1.6s infinite ease;
                span{
                  background: #71a2ff;
                  color: #5c8ce7;
                }
                p{
                  color: #FFF;
                }
              }
              &.zhan{
                color:#f45c43;
              }
              &.jin{
                visibility: hidden;
              }
            }
          }
        }
      }
      .seat_btn{
        width: 100%;
        text-align: center;
        margin-top: 30px;
        .van-button{
          border-radius: 70px;
          line-height: 70px;
          height: 70px;
        }
      }
    }
  }
</style>
